import htmlvalidation from "../../../../assets/images/docs/htmlvalidation.png";
import sourcepanel from "../../../../assets/images/docs/sourcepanel.png";
import * as React from 'react';
export default {
  htmlvalidation,
  sourcepanel,
  React
};